//--------------- IMPORTAÇÕES ---------------//
import { UsuariosContext } from "../context/UsuariosContext";
import { useContext } from "react";



//--------------- EXPORTAÇÃO DO COMPONENTE CONTAINER CREATE COMPANY ---------------//
export default function ContainerFilters() {



    //--------------- CRIAÇÃO DOS HOOKS ---------------//
    const {status, setStatus} = useContext(UsuariosContext);



    //--------------- RETORNO DO COMPONENTE CONTAINER CREATE COMPANY ---------------//
    return (
        <>

            {/* FILTRO DE STATUS DO USUÁRIO*/}
            <div className="flex flex-col w-full sm:max-w-[250px] mb-6">
                <label className="text-sm text-ink-3 mb-1">Status do Usuário</label>
                <select
                    value={status}
                    onChange={(e) => { setStatus(e.target.value) }}
                    className="truncate bg-surface-2 border border-white/[0.12] px-4 py-2 rounded text-sm text-white focus:outline-none focus:ring-2 h-[40px] focus:ring-brand-500"
                >
                    <option value="">Todos</option>
                    <option value="ativos">Ativos</option>
                    <option value="inativos">Inativos</option>
                </select>
            </div>

        </>
    )
}